import { Observable } from 'rxjs';
import { share, finalize } from 'rxjs/operators';

type Thunk<T> = () => Observable<T>;

/**
 * returns a function that spits out the same observable for every call
 * until that observable completes, at which point it will create a new one
 */
export function makeObservableBarrier<T>(thunk: Thunk<T>): Thunk<T> {
  let barrier: Observable<T> = null;

  return () => {
    if (barrier === null) {
      barrier = thunk().pipe(
        // eslint-disable-next-line no-return-assign
        finalize(() => barrier = null),
        share() // share hot amongst subscribers, don't kick off a new one on subscribe
      );
    }

    return barrier;
  };
}
